/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { useLocation } from 'react-router-dom';
import { MainLayout } from '@/components/layout';
import { prescriptionApi } from '@/api';
import { GetOrderStatusInterface } from '@/types';
import {
  errorHandlingGlobal,
  generateQueryParamsFromStringQuery,
} from '@/utils/helper';
import LanguagePreferenceBar from '../LanguagePreferenceBar';
import DoctorProfileBar from './components/DoctorProfileBar';
import LifepackXkemenkesLogo from './components/LifepackXkemenkesLogo';
import StatusListBar from './components/StatusListBar';

const PrescriptionStatus = () => {
  const [orderStatus, setOrderStatus] = useState<GetOrderStatusInterface[]>(
    [] as GetOrderStatusInterface[]
  );

  const location = useLocation();
  const queryParamsObjectFromURL = generateQueryParamsFromStringQuery(
    location.search
  );
  const queryParams = {
    time_period: queryParamsObjectFromURL.time_period as string,
    sort_by: '-created_at',
  };

  const getOrderStatus = async () => {
    try {
      const { data } = await prescriptionApi.getOrderStatus(queryParams);
      setOrderStatus(data);
    } catch (error) {
      errorHandlingGlobal(error);
    }
  };

  useEffect(() => {
    getOrderStatus();
  }, []);

  return (
    <MainLayout hideBanner>
      <MetaTags>
        <title>Prescription Status</title>
      </MetaTags>
      <LanguagePreferenceBar />
      <LifepackXkemenkesLogo />
      <DoctorProfileBar />
      <StatusListBar orderStatus={orderStatus} />
    </MainLayout>
  );
};

export default PrescriptionStatus;
